import { SetStateAction, useMemo } from 'react'


import debounce from 'debounce'
import { Select } from 'flowbite-react';

import Loader from '@/components/Loader'
import TableItem from '@/components/Table'
import PaginationItem from '@/components/Table/pagination-item'
import SearchTableItem from '@/components/Table/search'
import { useEditarPedidosContext } from '@/contexts/editar-pedido.context'
import { TABLE_HEADERS_EDITAR_PEDIDO_ERROS } from '@/pages/Pedidos/constants'

const EditarPedidosErrosGrid = () => {
  const {
    listarItensVendaComErro,
    listarItensVendaComErroPageSize,
    setlistarItensVendaComErroPageSize, setListarItensVendaComErroPage,
    listarItensVendaComErrotalPages,
    setSearchlistarItensVendaComErro,
    isLoadinglistarItensVendaComErro } = useEditarPedidosContext()

  const handleSearch = debounce((e: SetStateAction<string>) => {
    setListarItensVendaComErroPage(1)
    setSearchlistarItensVendaComErro(e)
  }, 500)

  const mappedVendaV2 = useMemo(() => {
    if (!listarItensVendaComErro?.conteudo?.resultados) return [];

    return listarItensVendaComErro.conteudo.resultados.map(item => ({
      motivo: item.mensagem,
    }));
  }, [listarItensVendaComErro]);

  return (
    <>
      <span className='text-quaternary pb-3 text-lg m-1'>
        Erros encontrados
      </span>
      <div className='flex justify-between gap-2 ml-1 p-3 pb-0'>
        <SearchTableItem
          isAddItem={false}
          isSearchInputEnabled={true}
          setFilterText={e => handleSearch(e)}
        />
      </div>
      {isLoadinglistarItensVendaComErro ? (
        <div
          className='h-96 w-full flex justify-center items-center'
          data-testid='loader-table-erros'
        >
          <Loader size={'xl'} />
        </div>
      ) : (
        <div
          className='flex flex-col md:grid grid-cols-12 w-full p-1'
          data-testid='table-erros'
        >
          <div className='flex flex-col col-span-12 gap-2'>
            <TableItem
              isActions={false}
              isRowClicable={false}
              data={mappedVendaV2 || []}
              headers={TABLE_HEADERS_EDITAR_PEDIDO_ERROS}
              deleteAction={() => void 0}
              hasCustomActions={false}
              idKey='vendaId'
              isIdle={isLoadinglistarItensVendaComErro}
            />
            <PaginationItem
              totalItems={
                listarItensVendaComErro?.conteudo?.resultados.length ?? 0
              }
              totalPages={listarItensVendaComErrotalPages}
              pageSize={listarItensVendaComErroPageSize}
              onPageChange={(pageParam: number) => setListarItensVendaComErroPage(pageParam)}
              forceDisplay={true}
            >
              <Select
                id='select-page-size-listar-itens-venda-com-erro'
                data-testid='select-page-size-listar-itens-venda-com-erro'
                onChange={e => {
                  setlistarItensVendaComErroPageSize(Number(e.target.value))
                  setListarItensVendaComErroPage(1)
                }}
                value={listarItensVendaComErroPageSize}
              >
                <option value='10'>10</option>
                <option value='25'>25</option>
                <option value='50'>50</option>
                <option value='100'>100</option>
              </Select>
            </PaginationItem>

          </div>
        </div>
      )}
    </>
  )
}

export default EditarPedidosErrosGrid